const USER_MANAGEMENT_PATH = '/app/manage/users/';

export { USER_MANAGEMENT_PATH };
